import React from "react";
import { connect } from "react-redux";
import Checkbox from "@material-ui/core/Checkbox";
import classes from "../columns.css";
import { isUncoded, isMatchable, isUnappliedRule } from "../columnsHelpers";

const BatchTickbox = ({
  isRah,
  filterBy,
  matches,
  rows,
  selectTransactions,
  selectedTransactions,
}) => {
  const transactions = rows ? Object.values(rows).filter(item => {
    if (filterBy === 'Uncoded') {
      return isUncoded(item, isRah) || item.notCoded;
    } else if (filterBy === 'Coded') {
      return !isUncoded(item, isRah) || item.notCoded;
    } else if (filterBy === 'Unmatched') {
      return isMatchable(item, matches)
    } else if (filterBy === 'Matched') {
      return item.MatchId;
    } else if (filterBy === 'Unapplied Rules') {
      return isUnappliedRule(item);
    } else return true;
  }) : [];
  const transactionLength = transactions.filter(x => !x.isTransactionLocked).length;
  const selectedLength = selectedTransactions.length;
  const isAllUnselected = selectedLength === 0;
  const isAllSelected = !isAllUnselected && (selectedLength === transactionLength);
  const indeterminate = !isAllSelected && !isAllUnselected;

  const selectFilteredTransactions = () => {
    const newTransactions = isAllSelected ? [] : transactions.filter(x => !x.isTransactionLocked);
    selectTransactions(newTransactions);
  }

  return (
    <div className={classes.marginTop10}>
      <div>
        <Checkbox
          tabIndex={-1}
          onChange={selectFilteredTransactions}
          checked={Boolean(transactionLength > 0 && isAllSelected)}
          indeterminate={indeterminate}
          color="default"
        />
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    selectedTransactions: state.transactions.selectedTransactions,
    filterBy: state.transactions.filterBy,
  };
}

export default connect(mapStateToProps)(BatchTickbox);



// WEBPACK FOOTER //
// ./src/components/TransactionList/Columns/SelectBox/batchTickbox.js